import {gql} from '@apollo/client';

export const CREATE_BCP_CHECK_JOB = gql`
    mutation CreateBcpCheckJob($input: CreateCheckJobInput!) {
        createBcpCheckJob(input: $input) {
            success
            code
            message
            data {
                id
                name
                status
            }
        }
    }
`;

export const UPDATE_BCP_CHECK_JOB = gql`
    mutation UpdateBcpCheckJob($id: Long!, $input: CreateCheckJobInput!) {
        updateBcpCheckJob(id: $id, input: $input) {
            success
            code
            message
        }
    }
`;

export const PUBLISH_BCP_CHECK_JOB = gql`
    mutation PublishBcpCheckJob($id: Long!) {
        publishBcpCheckJob(id: $id) {
            success
            code
            message
        }
    }
`;

export const ENABLE_BCP_CHECK_JOB = gql`
    mutation EnableBcpCheckJob($id: Long!) {
        enableBcpCheckJob(id: $id) {
            success
            code
            message
        }
    }
`;

export const DISABLE_BCP_CHECK_JOB = gql`
    mutation DisableBcpCheckJob($id: Long!) {
        disableBcpCheckJob(id: $id) {
            success
            code
            message
        }
    }
`;

export const DELETE_BCP_CHECK_JOB = gql`
    mutation DeleteBcpCheckJob($id: Long!) {
        deleteBcpCheckJob(id: $id) {
            success
            code
            message
        }
    }
`;

export const ROLLBACK_BCP_CHECK_JOB_CONFIG_VERSION = gql`
    mutation RollbackBcpCheckJobConfigVersion($jobId: Long!, $version: Long!) {
        rollbackBcpCheckJobConfigVersion(jobId: $jobId, version: $version) {
            success
            code
            message
        }
    }
`;

export const DEBUG_BCP_CHECK_JOB = gql`
    mutation DebugBcpCheckJob($input: DebugBcpCheckInput!) {
        debugBcpCheckJob(input: $input) {
            success
            code
            message
            data {
                records {
                    tableName
                    status
                    relatedKey
                    fields
                }
                checkResults {
                    relatedKey
                    resultCode
                    failReason
                    data
                }
            }
        }
    }
`;
